import { ServerPostMessageApi } from 'cadenza/utils/post-message/server-post-message-api';

export const TableViewMessageTypes = {
  /**
   * Row selection changed event.
   *
   * @type {string}
   */
  ROW_SELECTION_CHANGED: 'ROW_SELECTION_CHANGED',

  /**
   * State changed event.
   *
   * @type {string}
   */
  STATE_CHANGED: 'STATE_CHANGED'
};

/**
 * TableView API for communicating with the content loaded in its iframe.
 */
export class TableViewApi extends ServerPostMessageApi {

  /**
   * Informs about a changed state
   *
   * @param {string} newState - The new state
   * @param {object} data - Data corresponding to the new state
   * @return {Promise.<void|NoEndpointDefinedError>} A promise reflecting the receiving of the request on iframe content side.
   */
  stateChanged (newState, data = undefined) {
    return this.request({ type: TableViewMessageTypes.STATE_CHANGED, detail: { newState, data } });
  }

}
